/**
 * Description Component
 *
 * Property description with expand/collapse.
 */

import React, { useState } from 'react';

interface DescriptionProps {
  description: string;
  maxLength?: number;
}

export const Description: React.FC<DescriptionProps> = ({
  description,
  maxLength = 500,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const shouldTruncate = description.length > maxLength;
  const displayText = shouldTruncate && !isExpanded
    ? description.slice(0, maxLength) + '...'
    : description;

  return (
    <section className="py-6 border-b border-gray-200">
      <h2 className="text-xl font-semibold text-gray-900 mb-4">
        About this place
      </h2>

      <div className="text-gray-700 whitespace-pre-line leading-relaxed">
        {displayText}
      </div>

      {shouldTruncate && (
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="mt-4 flex items-center gap-1 text-gray-900 font-medium underline underline-offset-4 hover:text-primary-600"
        >
          {isExpanded ? 'Show less' : 'Show more'}
          <ChevronIcon
            className={`w-4 h-4 transition-transform ${
              isExpanded ? 'rotate-180' : ''
            }`}
          />
        </button>
      )}
    </section>
  );
};

const ChevronIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
  </svg>
);

export default Description;
